import React from 'react';
import data from '../../assets/json/about.json';

const Hero = props => (
  <div className="home-hero">
    <div className="title-wrapper">
      <h1 className="name">{data.hero.name}</h1>
      <span className="title">{data.hero.title}</span>
      <span className="subtitle">{data.hero.subtitle}</span>
    </div>
  </div>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/home/Hero.js